<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Доставка кофе</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <p style="margin-top:2%;">Мы привезем Вам вкусный горячий кофе домой или в офис. Быстро!</p>
            <p>Лучшие бариста города готовы побороться за Ваш выбор чтобы Вы могли заказать с доставкой Капучино, Американо, Эспрессо, Гляссе, Раф-Кофе, а также Горячий шоколад.</p>
            <p>Мы очень трепетно относимся к тому,  чтобы свежий ароматный кофе доставили Вам горячим, поэтому доставка осуществляется с использованием специальных термо-контейнеров. При этом время доставки кофе мы сократили до минимума, чтобы Вам не пришлось долго ждать горячо любимый напиток.</p>
            <p>Вместе с кофе на десерт Вы можете заказать доставку вкусной выпечки – оригинального печенья, тортиков, других сладостей.</p>
            <p><br/><center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/coffee1.jpg" alt="Доставка кофе" width="700" /></center></p>
            <p style="margin-top:2%;">Хотите не просто перекусить, а чего-то более существенного? Закажите доставку кофе, <router-link to="/pizza">пиццы</router-link>, <router-link to="/burger">бургеров</router-link> или чего-то еще.</p>
            <p>Кофе давно перестал быть просто напитком – это неотъемлемая часть нашей жизни и уж точно постоянный спутник жителей больших городов.</p>
            <p>На сервисе Хочу-Поесть множество кофеен, которые не просто варят вкусный кофе, но и создают вокруг этого целое действо: разные степени обжарки, искусные моносорты и блэнд-смеси, speciality арабики, особенный почерк бариста в каждом глотке изысканного кофе. У вас есть возможность попробовать атмосферу на вкус лучших кофеен города.</p>
            <p>Вкуснейший горячий кофе с доставкой! Закажи доставку в любое время! И не только кофе. </p>
            <p style="margin-top:2%;">Твоей любимой кофейни нет на нашем сервисе? Напиши нам об этом. И мы отправимся к ним. <a href="mailto:pr@hochu-poest.com">pr@hochu-poest.com</a></p>
            <router-link :to="'/product/27'" tag="div">
              <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'coffee'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/coffee.vue